import React from 'react';
import { Send, Users, MessageSquare, ExternalLink } from 'lucide-react';
import './TelegramCommunity.css';

const TelegramCommunity = () => {
  const telegramGroupLink = "https://t.me/+Y3nvJ-qnCXs3YzFh";
  
  return (
    <div className="telegram-community">
      <div className="telegram-hero">
        <div className="telegram-icon-wrapper">
          <Send size={48} />
        </div>
        <h1>Join Our Telegram Community</h1>
        <p>Connect with fellow traders, get real-time updates, and be part of the HyperDrive family!</p>
      </div>

      <div className="telegram-features">
        <div className="feature-card">
          <div className="feature-icon">
            <MessageSquare size={24} />
          </div>
          <h3>Build Community</h3>
          <p>Build community with traders at all levels, growing and learning together</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <Users size={24} />
          </div>
          <h3>Community Support</h3>
          <p>Get help from experienced traders and Coach CJ</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <Send size={24} />
          </div>
          <h3>Instant Alerts</h3>
          <p>Receive live stream notifications and important announcements</p>
        </div>
      </div>

      <a 
        href={telegramGroupLink}
        target="_blank"
        rel="noopener noreferrer"
        className="telegram-join-btn"
      >
        <Send size={20} />
        Join HyperDrive Telegram
        <ExternalLink size={16} />
      </a>

      <p className="telegram-note">
        Click the button above to join our private Telegram community
      </p>
    </div>
  );
};

export default TelegramCommunity;
